import { render } from "./TrainerRow.vue?vue&type=template&id=1cdba428&scoped=true"
import script from "./TrainerRow.vue?vue&type=script&lang=js"
export * from "./TrainerRow.vue?vue&type=script&lang=js"

import "./TrainerRow.vue?vue&type=style&index=0&id=1cdba428&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdba428"]])

export default __exports__